import { useEffect, useRef, useState } from 'react';
import { ModalFrame } from './Sheets';
export function CaseForm({ close, commit, firstRun }: { close: () => void; commit: (label: string) => Promise<void>; firstRun: boolean }) {
  const [label, setLabel] = useState('');
  const [error, setError] = useState('');
  const errorRef = useRef<HTMLParagraphElement>(null);
  useEffect(() => { if (error) errorRef.current?.focus(); }, [error]);
  return <ModalFrame title={firstRun ? '첫 기사 저장 전 · 기록 이름' : '새 기사 묶음 만들기'} close={close}>
    <form onSubmit={async (event) => { event.preventDefault(); try { await commit(label); } catch { setError('기록 이름은 2자에서 80자 사이로 적어 주세요.'); } }}>
      <p className="notice">같은 사건의 후속 기사와 정정을 한곳에 모아 볼 이름이에요.</p>
      {error && <p ref={errorRef} className="notice danger" role="alert" tabIndex={-1}>{error}</p>}
      <div className="form-grid">
        <label>기록 이름 (필수)<input autoFocus required minLength={2} value={label} maxLength={80} onChange={(event) => setLabel(event.target.value)} placeholder="예: 공공 발표 변경 내용" /><span className="field-help">나중에 다시 찾기 쉬운 이름으로 적어 주세요.</span></label>
      </div>
      <div className="form-actions"><button type="button" className="button secondary" onClick={close}>나중에</button><button className="button primary">기사 주소 입력하기</button></div>
    </form>
  </ModalFrame>;
}

